import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import classNames from 'classnames/bind';
import style from './Article.scss';
const ctx = classNames.bind(style);

import Steps from './blocks/Steps';
import SocialSharing from './blocks/SocialSharing';
import Title from './blocks/Title';

import scrollIntoView from 'scroll-into-view';
import ArticleSpreader from '../ArticleSpreader';

class Article extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    props.children.map((_, idx) => {
      this.stepsRefs[idx] = React.createRef();
    });
  }

  stepsRefs = {};

  getStepRef = name => this.stepsRefs[name].current;

  handleChooseStep = name => {
    const nodeRef = this.getStepRef(name);
    const node = ReactDOM.findDOMNode(nodeRef);

    if (node) {
      scrollIntoView(node, { align: { top: 0.1 } });
    }
  };

  render() {
    const { children: steps, showSocialSharing, banner } = this.props;

    const activeStepIdx = 0; //this.getActiveStep();

    return (
      <div className={ctx('article')}>
        {banner}
        {steps.map((step, idx) => {
          const isFirstStep = idx === 0;

          return (
            <div key={idx}>
              <ArticleSpreader>
                <div className={ctx('mobile-steps')}>
                  {isFirstStep && (
                    <div className={ctx('steps')}>
                      <Steps
                        steps={steps}
                        activeIdx={activeStepIdx}
                        onChooseStep={this.handleChooseStep}
                      />
                    </div>
                  )}
                </div>
                <div ref={this.stepsRefs[idx]} />
                <Title title={step.title} />
                <div className={ctx('mobile-steps')}>
                  {showSocialSharing ? (
                    <div className={ctx('social')}>
                      <SocialSharing />
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
                <div className={ctx('desktop-sidebar')}>
                  <div className={ctx('base')}>
                    <div className={ctx('content')}>
                      {isFirstStep && (
                        <Steps
                          steps={steps}
                          activeIdx={activeStepIdx}
                          className={ctx('steps')}
                          onChooseStep={this.handleChooseStep}
                        />
                      )}
                      {showSocialSharing ? <SocialSharing /> : <div />}
                    </div>
                  </div>
                </div>
              </ArticleSpreader>
              {step.body}
            </div>
          );
        })}
      </div>
    );
  }
}

export default Article;

/*
        
*/
